
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2605206c&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PromptSideBarStudentNotepad.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PromptSideBarStudentNotepad.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2605206c!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PromptSideBarStudentNotepad.vue"),
  /* scopeId */
  "data-v-2605206c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/PromptSideBarStudentNotepad.vue
// module id = 1823
// module chunks = 61